export default __webpack_public_path__ + "static/2_1-45bc883e60a1ac2c994435c0fd2e1092.jpeg";